import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import SpeakerFileUpload from './speaker-file-upload';
import SponsorFileUpload from './sponsor-file-upload';
import ExhibitorFileUpload from './exhibitor-file-upload';

class FileUpload extends Component {

  constructor(props) {
    super(props);

    this.state = {

    };
  }

  render() {
    var style = {
      width: '30%',
      padding: '10px',
      margin: '10px',
      border: 'solid 1px #333',
      borderRadius: '5px'
    }
    return (
      <div>
        <table style={{width: '100%'}}>
          <tbody>
            <tr>
              <td style={style}><SpeakerFileUpload /></td>
              <td style={style}><SponsorFileUpload /></td>
              <td style={style}><ExhibitorFileUpload /></td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }

}

const mapStateToProps = (state) => ({
  session: state.session
});

const mapDispatchToProps = (dispatch) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(FileUpload);
